import React, { useState } from "react"
import cls from "classnames"
import { Review, Props as ReviewProps } from '../Review'
import * as styles from './styles.module.scss';
import Slider, { SliderProps } from "../Slider"
import {IdHeading} from "components/organisms/IdHeading";
type Item = ReviewProps & {
    id: number
}

type Props = {
    items: Item[]
    title?: string
    subtitle?: string
    theme?: string
    className?: string
}


export const ReviewsSlider = ({ title, subtitle, items, theme = 'light', className }: Props) => {
    let cardTheme: string = theme === 'light' ? 'dark' : 'light';

    return (
        <div className={cls(styles.container, styles[theme], className)}>
            <div className={"bs-flex-container l"}>
                {title && <IdHeading className={styles.title}>{title}</IdHeading>}

                {subtitle && <IdHeading headingLevel={5} className={styles.subtitle}>{subtitle}</IdHeading>}
            </div>

            <Slider arrows={false} variableWidth={true} theme={theme} infinite={true}>
                {items.map(({ id, title, description, details, image }, index) => (
                        <Review
                            key={id}
                            title={title}
                            description={description}
                            details={details}
                            image={image}
                            theme={cardTheme}
                            className={styles.review}
                        />
                ))}
            </Slider>
        </div>
    )
}
